<template>
  <div class="report-fs">
    <h3 class="text-center fs-head-co">{{ allData.fullName }}</h3>
    <h3 class="text-center fs-head-co">{{ allData.shortName }}</h3>
    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>

    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">
                  عدد أيام
                  {{
                    TypeT == "1"
                      ? "الحضور المتأخر"
                      : TypeT == "2"
                      ? "الخروج المبكر"
                      : TypeT == "3"
                      ? "الغياب"
                      : ""
                  }}
                  من {{ convertToUi(DateFrom) }} الى {{ convertToUi(DateTo) }}
                </h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell class="border-staffLists">ر.م</md-table-cell>

                    <md-table-cell class="border-staffLists"
                      >الاسم</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >الرقم الوظيفي</md-table-cell
                    >
                    <md-table-cell class="border-staffLists"
                      >أيام العمل</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >عدد الأيام</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >الأيام</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      i + 1
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.jobNumber
                    }}</md-table-cell>
                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.workDays
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.daysCount
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">
                      <div
                        style="padding-top: 10px; padding-left: 20px"
                        v-for="(item, i) in item.details"
                        :key="i"
                      >
                        {{ "(" + convert(item.date) + ")" }}
                      </div>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: ["data", "pathLogo", "allData", "TypeT", "DateFrom", "DateTo"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    converty(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>